import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import cx from "classnames";
import { uploadFile } from "react-s3";
import * as loaderAction from "../../redux/loader/action";
import StatusMessage from "./StatusMessage";
// import awsconfig from "../../components/aws-config/awsconfig.js";
// import Amplify, { Auth } from "aws-amplify";

const config = {
  bucketName: "gameapart-assets",
  region: "us-east-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
};

function Pdf(props) {
  const { handle_submit } = props;
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const hero_label = _.get(joining_data, "pdf.hero_label", "Upload Hero");
  const slidekick_label = _.get(
    joining_data,
    "pdf.slidekick_label",
    "Upload SlideKick"
  );
  const slidekick_only = _.get(
    joining_data,
    "slides.slidekick_only",
    "Slidekick only"
  );
  const game_state = _.get(props, "gameReducer.roomObj.game_state");
  const slidekick_status = _.get(game_state, "slidekick_status");
  const hero_status = _.get(game_state, "hero_status");

  const { pdf_hero_link, handle_hero_link } = props;
  const { pdf_slidekick_link, handle_slidekick_link } = props;
  const { pdf_slidekick_only, handle_slidekick_only } = props;
  const { show_pdf_status } = props;

  const hero_file_input = useRef();
  const slidekick_file_input = useRef();

  const on_submit = (e, link, type) => {
    // e.preventDefault();
    handle_submit(link, type, pdf_slidekick_only, "pdf");
  };

  // Amplify.configure(awsconfig);
  useEffect(() => {
    if (pdf_slidekick_only) {
      if (slidekick_status && slidekick_status === "Good") {
        props.setopenRoomDisabled(false);
      } else {
        props.setopenRoomDisabled(true);
      }
    } else {
      if (
        slidekick_status &&
        slidekick_status === "Good" &&
        hero_status &&
        hero_status === "Good"
      ) {
        props.setopenRoomDisabled(false);
      } else {
        props.setopenRoomDisabled(true);
      }
    }
  }, [slidekick_status, pdf_slidekick_only, hero_status]);

  const handle_file = (e, type) => {
    if (e.target.files.length > 0) {
      props.setIsLoading(true);
      let file = e.target.files[0];
      if (type === "hero") {
        uploadFile(file, config)
          .then((data) => {
            props.setIsLoading(false);
            handle_hero_link(data.location, "pdf");
          })
          .catch((err) => console.error(err, "file data err"));
      } else if (type === "slidekick") {
        uploadFile(file, config)
          .then((data) => {
            props.setIsLoading(false);
            handle_slidekick_link(data.location, "pdf");
          })
          .catch((err) => console.error(err, "file data err"));
      }
    }
  };

  return (
    <div className="pdf-container">
      <div
        className={cx("hero-container", { disabled: pdf_slidekick_only })}
        disabled={pdf_slidekick_only}
      >
        <h1>{hero_label}</h1>
        <div className="d-flex justify-content-between">
          <input
            readOnly
            type="text"
            placeholder="Browse for file..."
            className="form-control"
            value={pdf_hero_link}
            onChange={(e) => handle_hero_link(e.target.value, "pdf")}
          />
          <button
            className="btn btn-search"
            onClick={() => hero_file_input.current.click()}
          >
            <i className="fa fa-search"></i>
            <input
              type="file"
              ref={hero_file_input}
              onChange={(e) => handle_file(e, "hero")}
              style={{ display: "none" }}
            />
          </button>
          <button
            className="btn"
            onClick={(e) => on_submit(e, pdf_hero_link, "hero")}
          >
            OK
          </button>
        </div>
        {hero_status && show_pdf_status && <StatusMessage hero={true} />}
      </div>
      <div className="slideKick-container">
        <div className="d-flex justify-content-between">
          <h1>{slidekick_label}</h1>
          <div>
            <input
              type="checkbox"
              id="slideKick-only"
              onClick={() => handle_slidekick_only("pdf")}
              checked={pdf_slidekick_only}
              className="mr-3"
            />
            <label htmlFor="slideKick-only" className="slideKick-only">
              {slidekick_only}
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <input
            readOnly
            type="text"
            placeholder="Browse for file..."
            className="form-control"
            value={pdf_slidekick_link}
            onChange={(e) => handle_slidekick_link(e.target.value, "pdf")}
          />
          <button
            className="btn btn-search"
            onClick={() => slidekick_file_input.current.click()}
          >
            <i className="fa fa-search"></i>
            <input
              type="file"
              ref={slidekick_file_input}
              onChange={(e) => handle_file(e, "slidekick")}
              style={{ display: "none" }}
            />
          </button>
          <button
            className="btn"
            onClick={(e) => on_submit(e, pdf_slidekick_link, "slidekick")}
          >
            OK
          </button>
        </div>
        {show_pdf_status && slidekick_status && (
          <StatusMessage slidekick={true} />
        )}
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pdf);
